import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class HealthExSupportService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async requestSupport(input) {
        await axios.post(generateURL(this.environment.API_BASE_URL, "/request-support"), input, await authenticatedApiConfig(this.authenticationProvider));
    }
}
